<template>
  <!-- Implementa un componente che mostra una tabella per la visione di tutti
       i messaggi ricevuti od inviati nel sistema di notifiche interno da parte
       dell'utente. Al click su una riga della tabella viene mostrata a schermo
       una modale con il contenuto del messaggio. Se siamo in modalità ricevuti
       sono evidenziati anche i messaggi ricevuti ma ancora non letti -->
  <div>
    <!-- CARD DI CONTENIMENTO DELLA TABELLA -->
    <b-card no-body class="mr-1 ml-1">
      <b-card-header>
        <h5><b-icon icon="envelope-open" class="mr-1"></b-icon> {{table_title}}</h5>
      </b-card-header>
      <b-card-body>
        <!-- Form con il filtro e la select delle pagine visualizzabili, essendo solo selezioni non usiamo b-form   -->
        <!-- se la tabella è utilizzata per i messaggi ricevuti viene inserito anche il pulsante per contrassegnare -->
        <!-- tutti i messaggi come letti.                                                                           -->
        <b-row>
          <b-col cols="12" md="2">
            <b-form-group id="group-n-righe-per-pagina"
              label="Righe per pagina:"
              label-for="n_elementi"
            >
              <b-form-select id="n_righe_per_pagina"
                v-model="datatable.per_page"
                :options="datatable.righe_per_pagina">
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group id="group-filtro-tabella"
              label="Ricerca:"
              label-for="filtro_tabella"
              description="Ricerca all'interno degli elementi della pagina corrente">
              <b-form-input
                id="filtro_tabella"
                v-model="datatable.filter">
                </b-form-input>
            </b-form-group>
          </b-col>
          <!-- In modalità ricevuti ed archivio non abbiamo questa funzionalità -->
          <b-col v-if="is_mode_ricevuti" cols="12" md="3" class="my-auto pb-2">
            <b-button variant="primary" @click="contrassegna_tutti_come_letti">
              Contrassegna tutti come letti
            </b-button>
          </b-col>
        </b-row>
        <!-- QUI LA TABELLA --->
        <!-- no-provider-sorting e no-provider-filtering evita che per ogni azione
             di sorting o filtraggio venga chiamato il backend, ma venga fatto dalla
             tabella stessa -->
        <b-table hover stacked="md"
                  ref="notificationstable"
                  :items="get_table_items"
                  :no-provider-filtering="true"
                  :no-provider-sorting="true"
                  :fields="datatable.fields"
                  :current-page="datatable.current_page"
                  :per-page="datatable.per_page"
                  :filter="datatable.filter"
                  show-empty
                  @row-clicked="onRowClick">

          <!-- TABLE BUSY SLOT -->
          <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
               chiamata la funzione che prende i dati get_table_items --->
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
              <strong class="text-primary">Caricamento...</strong>
            </div>
          </template>

          <!-- DATA CREATED SLOT -->
          <!-- Usiamo lo slot per visualizzare la data di creazione del messaggio per -->
          <!-- riformattarlo in italiano e per visualizzare l'icona che indica se il  -->
          <!-- messaggio è nuovo o meno, quest'ultima visualizzata solo se siamo in   -->
          <!-- modalità "ricevuti" -->
          <template v-slot:cell(created)="data">
            <p>
              <!-- Icona tipo messaggio letto/da leggere -->
              <span v-if="is_mode_ricevuti">
                <span v-if="data.item.conferma_lettura" class='mr-1'>
                  <b-icon icon='envelope-open' font-scale="1.5"></b-icon>
                </span>
                <span v-else class='mr-1' v-b-tooltip.hover title="Nuovo messaggio">
                  <b-icon icon='envelope-fill' font-scale="1.5" animation="cylon"></b-icon>
                </span>
              </span>
              <!-- Data creazione -->
              {{ data.value | toitadatetime }}
            </p>
          </template>

          <!-- ID RIFERIMENTO SLOT -->
          <!-- Usiamo lo slot per visualizzare un trattino quando non è specificato -->
          <!-- il numero della richiesta. -->
          <template v-slot:cell(id_riferimento)="data">
            <p v-if="data.value">{{data.value}}</p>
            <p v-else>-</p>
          </template>

          <!-- TESTO MESSAGGIO SLOT -->
          <!-- Il messaggio va formattato in modo tale che sia renderizzato come un html -->
          <!-- per questo utilizziamo lo slot e la direttiva v-html -->
          <template v-slot:cell(testo)="data">
            <p v-html="data.value" :style="{ height : '100px', overflow : 'hidden' }"></p>
          </template>

          <!-- EMPTY SLOT -->
          <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
               la proprietà "show-empty" alla tabella -->
          <template v-slot:empty>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Non ci sono messaggi</p>
          </template>

          <!-- EMPTYFILTERED SLOT -->
          <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
               la proprietà "show-empty" alla tabella -->
          <template v-slot:emptyfiltered>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
          </template>
        </b-table>
        <div class="mt-3">
          <p class="text-center">Sono presenti {{datatable.total_rows}} messaggi.</p>
          <b-pagination v-model="datatable.current_page" :total-rows="datatable.total_rows" :per-page="datatable.per_page" align="center"></b-pagination>
        </div>
      </b-card-body>
    </b-card>

    <!-- MODALE PER IL DETTAGLIO DEL MESSAGGIO -->
    <b-modal ref="modale_messaggio" size="xl" title="Dettaglio del messaggio.">
      <b-row>
        <b-col><b>Data:</b> {{message_detail.created | toitadatetime}}</b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col><b>Mittente:</b> {{message_detail.nome_mittente}}</b-col>
      </b-row>
      <b-row v-if="show_dest" class="mt-2">
        <b-col>
          <p class='mb-0'><b>Destinatari:</b></p>
          <p id="destbox">{{message_detail.nomi_destinatari}}</p>
        </b-col>
      </b-row>
      <b-row v-if="message_detail.id_riferimento" class="mt-1">
        <b-col><b>N. Richiesta:</b> {{message_detail.id_riferimento}}</b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col><b>Messaggio:</b></b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="mr-2 ml-2"><p v-html="message_detail.messaggio"></p></b-col>
      </b-row>
      <template v-slot:modal-footer="{ cancel }">
          <b-button variant="primary" size="sm" class="float-right" @click="cancel()">
            Chiudi
          </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'TabellaNotifiche',
  data () {
    return {

      // Oggetto con le info per la tabella
      datatable : {
        // Definizione delle colonne per la tabella.
        fields: [
          {
            key: 'created',
            label: 'Data',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'nome_mittente',
            label : 'Mittente',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'id_riferimento',
            label: 'N. Richiesta',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key : 'testo',
            sortable: false,
            tdClass: 'message_column',
            thStyle: { backgroundColor: '#b3b3b3' }
          }
        ],

        // Elementi per pagina selezionabili
        righe_per_pagina : [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 25, text: "25" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
          { value: 200, text: "200" }
        ],

        // Pagina corrente
        current_page : 1,

        // Elementi visualizzabili per pagina, viene modificato
        // dal valore di "righe_per_pagina"
        per_page : 5,

        // Righe totali
        total_rows : 0,

        // Filtro di ricerca.
        filter : null
      },

      // Oggetto per il dettaglio del messaggiom ha gli stessi
      // campi della riga e vengono settati di volta in volta quando si
      // seleziona la riga.
      message_detail : {
        created : "",
        nome_mittente : "",
        id_riferimento : "",
        messaggio : ""
      }

    }
  },
  computed : {
    /**
     * Una semplice computed che mi dice se sto lavorando in modalità
     * messaggi ricevuti di modo tale da non dover verificare la stringa
     * ogni volta.
     */
    is_mode_ricevuti : function () {
      return this.mode === 'ricevuti' ? true : false;
    },
    /**
     * Una computed che in base alla modalità in uso, effettiva/archivio, va a restituire
     * il corretto url da utilizzare per la visualizzazione dei messaggi.
     */
    url_notifiche_utente_list : function () {
      return this.archive ? apiUrl.archivioapi.archivio_notifiche_list : apiUrl.mailapi.notifiche_utente_list;
    },
    /**
     * Una computed che in base alla modalità in uso, effettiva/archivio, va a restituire
     * il corretto url da utilizzare per la marcatura dei singoli messaggi come letti.
     */
    url_marca_notifica_come_letta : function () {
      return this.archive ? apiUrl.archivioapi.marca_notifica_archiviata_come_letta : apiUrl.mailapi.marca_notifica_come_letta;
    },
    /**
     * Una computed che in base alla modalità in uso, effettiva/archivio, va a restituire
     * il corretto url da utilizzare per la marcatura di tutti i messaggi come letti.
     */
    url_marca_tutte_come_lette : function () {
      return this.archive ? apiUrl.archivioapi.marca_notifiche_archiviate_come_lette : apiUrl.mailapi.marca_tutte_le_notifiche_come_lette;
    }
  },
  methods: {
    /**
     * Interroga il backend e torna gli elementi per popolare la tabella.
     *
     * - ctx: è la variabile di contesto che ci serve per interrogare in maniera corretta il backend
     *        questa contiene le chiavi:
     *                   apiUrl: ""      : url da chiamare, nel nostro caso stringa vuota. Perchè chiamiamo l'url nell funzione e non usiamo la prop
     *                   currentPage: 1  : pagina da chiamare
     *                   filter: null    : variabile di filtro, null oppure pari alla stringa che vogliamo filtare ( VIENE FATTO LATO CLIENT - usiamo no-provider-filter )
     *                   perPage: 50     : numero di risultati per pagina
     *                   sortBy: ""      : stringa vuota a nome della colonna secondo il quale ordinare i dati ( VIENE FATTO LATO CLIENT - usiamo no-provider-sorting )
     *                   sortDesc: false : ordine di sorting, sempre presente, può essere true o false
     *
     * - callback: funzione di callback da chiamare quando i dati sono pronti.
     */
    get_table_items : function (ctx, callback) {

      // Sistemiamo il contesto della chiamata get con la pagina voluta e la sua dimensione,
      // settiamo poi correttamente la modalità di richiesta dei messaggi se ricevuti o inviati.
      let page_mode = this.is_mode_ricevuti ? 'ricevuti' : 'inviati';
      let get_params = { page : ctx.currentPage, page_size : ctx.perPage, mode : page_mode };

      axios.get( this.url_notifiche_utente_list, { params : get_params } )
      .then( (response) => {
        // Settiamo il numero totale di righe e torniamo i dati
        this.datatable.total_rows = response.data.count;
        callback ( response.data.results );
      })
      .catch( (error) => {
        //generalLib.backend_error_message_box( this, error.response.data );
        console.error( error );
        callback ( [] );
      });
    },
    /**
     * Aggiorna la vista del dettaglio del messaggio e apre la modale
     * per la visualizzazione.
     * Se siamo nella modalità "ricevuti" si accupa anche di contrassegnare
     * il messaggio come letto ( questo forza un aggiornamento delle notifiche
     * da leggere senza aspettare il polling ).
     */
    onRowClick : function ( row )  {
      this.message_detail.created = row.created;
      this.message_detail.nome_mittente = row.nome_mittente;
      this.message_detail.nomi_destinatari = row.nomi_destinatari;
      this.message_detail.id_riferimento = row.id_riferimento;
      this.message_detail.messaggio = row.testo;
      if ( this.is_mode_ricevuti && row.conferma_lettura === false ){
        row.conferma_lettura = true;
        this.contrassegna_come_letto( row.id );
      }
      this.$refs['modale_messaggio'].show();
    },
    /**
     * Contrassegna il messaggio il cui id viene passato come letto
     * tramite la funzione di backend.
     * Forza poi un aggiornamento delle notifiche da leggere dopo che
     * è stato contrassegnato solo se non stiamo opernado in modalità
     * archivio, in questo caso non serve.
     *
     * - mess_id : id del messaggio
     */
    contrassegna_come_letto : function ( mess_id ) {

      let call_url = this.url_marca_notifica_come_letta.replace( '@mess_id', mess_id );

      axios.post( call_url )
      .then( (response) => {
        // La risposta torna un 204_NO_CONTENT se tutto ok, possiamo quindi forzare
        // l'aggiornamento dello stato delle notifiche senza aspettare il polling
        // per scalare quella letta. Se stiamo operando in modalità archivio questa
        // cosa non deve essere fatta.
        if ( !this.archive ) generalLib.aggiorna_stato_notifiche();
      })
      .catch( (error) => {
        generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Contrassegna tutti i messaggi del'utente come letti.
     * Successivamente invoca l'evento di refresh della tabella
     * per visualizzare il nuovo stato.
     * Ad operazioni terminate forza un aggiornamento delle notifiche
     * da leggere per visualizzare che non ve ne sono più da leggere.
     * Questa operazione non viene fatta però se stiamo agendo sui messaggi
     * in archivio.
     */
    contrassegna_tutti_come_letti : function () {

        const message = "Sei sicuro di contrassegnare tutti i messaggi come letti?"
        this.$bvModal.msgBoxConfirm( message, {
          title: 'Contrassegna tutti come letti',
          centered: true
        })
        .then( ( ok ) => {

          if ( !ok ) return;

          axios.post( this.url_marca_tutte_come_lette )
          .then( (response) => {
            // La risposta torna un 204_NO_CONTENT se tutto ok, possiamo quindi forzare
            // l'aggiornamento dello stato delle notifiche e lo stato stesso della tabella
            // di modo tale che poi tutte le cartoline che segnalano lo stato dei messaggi
            // appaiano aperte.
            // Non forziamo l'aggironamento delle notifiche se stiamo operando in modalità archivio
            // perchè in tal caso i messaggi che sono ancora non letti ma archiviati non sono
            // segnalati.
            if ( !this.archive ) generalLib.aggiorna_stato_notifiche();
            this.$refs.notificationstable.refresh();
          })
          .catch( (error) => {
            generalLib.backend_error_message_box( this, error.response.data );
          });
        });

    }
  },
  props : {
    /**
     * Indica la modalità operativa e può essere:
     * - ricevuti: visualizza i messaggi ricevuti dall'utente, è il default
     *             se non viene fornito nulla. In questo caso evidenzia con
     *             un'icona i messaggi ancora da leggere.
     * - inviati : visualizza i messaggi inviati dall'utente.
     */
    mode: {
      type: String,
      default: 'ricevuti',
      validator: function (value) {
        return [ 'ricevuti', 'inviati' ].includes(value)
      }
    },
    /**
     * Indica se la tabella è in modalità archivio, sta cioè visualizzando
     * i messaggi che sono stati messi da parte ma che restano comunque consultabili
     * dall'utente. Di default false.
     */
    archive: {
      type: Boolean,
      default: false
    },
    /**
     * Permette di nascondere i destinatari nel dettaglio del messaggio.
     * Questo è importante soprattutto se la visualizzazione è per i
     * messaggi ricevuti dall'utente di modo tale che non veda a quali
     * altri colleghi lo stesso messaggio è stato inviato.
     */
    show_dest: {
      type: Boolean,
      default: true
    },
    /**
     * Titolo della tabella.
     */
    table_title: {
      type: String,
      default: 'Notifiche Welfarebit'
    }
  }
}
</script>


<style scoped>
table :deep( .message_column ) {
  max-width:650px;
}
table :deep( tr ) {
  cursor:pointer;
}
#destbox{
  max-height: 100px;
  overflow-y: scroll;
}
</style>